import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // localStorage use hoga

// redux-persist config
const persistConfig = {
  key: 'root',
  storage,
  whitelist:['reducer'],
  blacklist: ["largeData", "images", "previewHtml"]
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// configure store with persisted reducer
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // persist ke sath yeh zaroori hota hai
    }),
});

// export store and persistor
export const persistor = persistStore(store);
export default store;
